"use client";

import deskTopImage from "@root/src/assets/images/contacts/desktop.png";
import tabLetImage from "@root/src/assets/images/contacts/tablet.png";
import mobileImage from "@root/src/assets/images/contacts/mobile.png";
import ResponsiveBanner from "@components/themes/lytra/common/ResponsiveBanner";

interface HeroBannerContactProps {
  alt: string;
}

export default function HeroBannerContact({ alt }: HeroBannerContactProps) {
  return (
    <ResponsiveBanner
      alt={alt}
      desktopSrc={deskTopImage}
      tabletSrc={tabLetImage}
      mobileSrc={mobileImage}
      priority
      sizes="100vw"
      backgroundColor="#f5eee0"
    />
  );
}
